import React, { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls";
import { Permissions, PermissionType } from "../../../util/Permissions";
import { Permission } from "../../Common/layout/Permission";
import DynamicSimpleTable from "../../../util/DynamicSimpleReactTable";
import cogoToast from "cogo-toast";
import { errorMessage, formatAsset, formatDate, formatStatus, formatUsername } from "../../../util/Helpers";
import { EditIcon, TrashIcon, ViewIcon } from "../../../util/Icons";
import CancelGiftCardModal from "./modals/CancelGiftCardModal";
import ViewGiftCardModal from "./modals/ViewGiftCardModal";
import EditGiftCardModal from "./modals/EditGiftCardModal";

export const GiftCardTable = ({ userGroup, userId }) => {
    const tableRef = useRef();

    const [giftCardModal, setGiftCardModal] = useState({
        showViewGiftCardModal: false,
        showEditGiftCardModal: false,
        showCancelGiftCardModal: false,
        details: null
    });

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setGiftCardModal({ ...giftCardModal, [modal]: !giftCardModal[modal] })
    }

    /* View Gift Card Modal */
    const viewGiftCard = details => {
        setGiftCardModal({ ...giftCardModal, showViewGiftCardModal: true, details });
    }

    /* Create or Update Gift Card Modal */
    const editGiftCard = details => {
        setGiftCardModal({ ...giftCardModal, showEditGiftCardModal: true, details });
    }

    /* Cancel Gift Card Modal */
    const cancelGiftCard = details => {
        setGiftCardModal({
            ...giftCardModal,
            showCancelGiftCardModal: true,
            details
        })
    }

    /* Action Buttons */
    const giftCardAction = (row) => {
        return (
            <span style={{ whiteSpace: "nowrap" }}>
                <Permission permission={Permissions.GIFT_CARDS} permissionType={PermissionType.READ}>
                    <Button
                        title="View Gift Card"
                        className="btn btn-icon btn-light btn-hover-primary btn-sm bg-white"
                        onClick={_ => viewGiftCard(row)}
                    >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            <ViewIcon />
                        </span>
                    </Button>
                </Permission>

                <Permission permission={Permissions.GIFT_CARDS} permissionType={PermissionType.UPDATE}>
                    <Button
                        title="Edit Gift Card"
                        className={`btn btn-icon btn-light btn-hover-primary btn-sm ml-3`}
                        onClick={_ => editGiftCard(row)}
                    >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            <EditIcon />
                        </span>
                    </Button>
                </Permission>

                <Permission permission={Permissions.GIFT_CARDS} permissionType={PermissionType.DELETE}>
                    <Button
                        title="Cancel Gift Card"
                        className={`btn btn-icon btn-light btn-hover-danger btn-sm ml-3`}
                        onClick={_ => cancelGiftCard(row)}
                    >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            <TrashIcon />
                        </span>
                    </Button>
                </Permission>
            </span>
        );
    };

    return (
        <>
            <Card>
                <CardHeader title={`Gift Cards`}>
                    {
                        !userId &&
                        <Permission permission={Permissions.GIFT_CARDS} permissionType={PermissionType.CREATE}>
                            <CardHeaderToolbar>
                                <Button onClick={_ => editGiftCard(null)}>Create Gift Card</Button>
                            </CardHeaderToolbar>
                        </Permission>
                    }
                </CardHeader>
                <CardBody>
                    <DynamicSimpleTable
                        key={`${userGroup}-gift-cards`}
                        queryParams={
                            `userGroup=${userGroup}`
                            + `${userId ? `&userId=${userId}` : ""}`
                        }
                        searchBox={false}
                        source={{ url: `/gift-cards` }}
                        columns={[
                            { title: "ID", key: "id" },
                            { title: "DESCRIPTION", key: "description" },
                            { title: "CURRENCY", key: "currency" },
                            { title: "ASSET", format: row => formatAsset(row?.asset?.id, row?.asset?.symbol, row?.asset?.imageUrl) },
                            // Only show user column if userId is absent (such as in user group gift cards section)
                            ...!userId
                                ? [{ title: "REDEEMED BY", format: row => formatUsername(row.userId, row.username, null, null, "gift-cards") }]
                                : [],
                            { title: "STATUS", format: row => formatStatus(row.status) },
                            { title: "CREATED AT", format: (row) => formatDate(row.createdAt) },
                            { title: "UPDATED AT", format: (row) => formatDate(row.updatedAt) },
                            { title: "", format: giftCardAction }
                        ]}
                        ref={tableRef}
                        onError={(err) =>
                            cogoToast.error(errorMessage(err))
                        }
                        refreshIcon={true}
                    />
                </CardBody>
            </Card>

            <ViewGiftCardModal
                {...giftCardModal}
                tableRef={tableRef}
                onHide={toggleModal("showViewGiftCardModal")}
            />

            <EditGiftCardModal
                {...giftCardModal}
                userGroup={userGroup}
                tableRef={tableRef}
                onHide={toggleModal("showEditGiftCardModal")}
            />

            <CancelGiftCardModal
                {...giftCardModal}
                tableRef={tableRef}
                onHide={toggleModal("showCancelGiftCardModal")}
            />
        </>
    );
};
